import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'antd';
import ScheduledSupersionModalWrapper from './styles/scheduled-supervision-modal.style';
import { getInitials } from '../../utils/getInititials';

class ScheduledSupersionModal extends Component {
    
    render() {
        const {supervisionData} = this.props

        if(!supervisionData) return null

        return (
                <Modal
                        width={445}
                        closable={false}
                        className="inviteModal"
                        visible={this.props.visible}
                        footer=""
                        style={{ zIndex: 2000 }}
                        
                        >
                <ScheduledSupersionModalWrapper>
                        <div className="scheduled-supervision">
                             <header>
                                <h1>You have a scheduled supervision</h1>    
                             </header>
                            <div className="scheduled-supervision-content">
                                <label>With</label>
                                <div class="therapist-profile">
                                    <span className="initial">{getInitials(supervisionData.firstName + " " + supervisionData.lastName)}</span>
                                    <div className="therapist-name">
                                        <h2>{supervisionData.firstName + " " + supervisionData.lastName}</h2>
                                        <h3>{supervisionData.mobileNumber}</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="_status">
                                <label>{supervisionData.topic}</label>
                                <h4>{supervisionData.startTime}</h4>
                            </div>
                            <div className="footer-action">
                                <a href="javascript:void(0)" className="join-room-link"  onClick={() => this.props.dismissSupervisionModal(1)}>Join {supervisionData.firstName}’s Video Room</a>
                            <div className="dismiss-modal" onClick={() => this.props.dismissSupervisionModal(0)}>Dismiss</div>
                            </div>
                         </div>
                </ScheduledSupersionModalWrapper>
                 </Modal>
                     
        );
    }
}

function mapStateToProps(state) {
	return state;
}
export default connect(mapStateToProps)(ScheduledSupersionModal);
